import PropTypes from 'prop-types';
import MLink from '@material-ui/core/Link';
import { httpUrl } from '../utils/urls';

const UrlLink = ({ url, raw }) => {
  if (!url) {
    return null;
  }
  return (
    <MLink href={httpUrl(url)} rel="noopener noreferrer">
      {raw ? url : url.replace(/^https?:\/\//, '').replace(/\/$/, '')}
    </MLink>
  );
};

UrlLink.propTypes = {
  url: PropTypes.string,
  raw: PropTypes.bool
};

export default UrlLink;
